export default __webpack_public_path__ + "static/media/uploading_3.31f1bc23.gif";